import React from 'react';
import { Link } from 'react-router-dom';
import { BlogCardProps } from '../types';
import { formatDate } from '../utils/formatDate';

const BlogCard: React.FC<BlogCardProps> = ({ post }) => {
  return (
    <Link to={`/blog/${post.slug}`}>
      <div className="group relative overflow-hidden mb-6">
        {/* <div 
          className="relative flex items-center justify-center h-64 overflow-hidden transition-all duration-300 group-hover:scale-110" 
          style={{
            backgroundImage: `url(${post.image})`,
            backgroundPosition: '50% 50%',
            backgroundSize: 'cover',
            color: '#111827'
          }}
        /> */}
      </div>
      <h4 className="heading-medium mb-2 text-primary" >
        {post.title.length > 60 ? `${post.title.substring(0, 60)}...` : post.title}
      </h4>
      <p className="body-normal text-gray-600">{post.author}</p>
      <p className="body-normal text-gray-600">
        <span className="text-gray-600">Published on {formatDate(post.publishedAt)}</span>
      </p>
    </Link>
  );
};

export default BlogCard; 